import { isEntityLoaded, isEntityLoading } from '@/Models/Entity';
import { type WorklistColumnViewParam } from '@/Models/GenericWorklist/WorklistParams';
import { type OrderForWorklist } from '@/Models/GenericWorklist/WorklistResult';
import { type IWorklistSortStore } from '../../Stores/WorklistSortStore';
import { type IWorklistStore } from '../../Stores/WorklistStore';

export default class WorklistDataGridHandler {
    private readonly worklistStore: IWorklistStore;
    readonly worklistSortStore: IWorklistSortStore;

    constructor(
        worklistSortStore: IWorklistSortStore,
        worklistStore: IWorklistStore,
    ) {
        this.worklistSortStore = worklistSortStore;
        this.worklistStore = worklistStore;
    }

    get ordersToDisplay(): OrderForWorklist[] {
        return this.worklistStore.orders;
    }

    get columnConfig(): WorklistColumnViewParam[] {
        return this.worklistStore.worklist.View.Columns;
    }

    get isLoadingData(): boolean {
        return isEntityLoading(this.worklistStore.results);
    }

    get hasResults(): boolean {
        return isEntityLoaded(this.worklistStore.results) && this.ordersToDisplay.length > 0;
    }

    get filterTooBroad(): boolean {
        return this.worklistStore.filterTooBroad;
    }
}
